export type AuthRole = "operator" | "moderator";

export interface RoleAuth {
  role: AuthRole;
  token: string;
}

const STORAGE_KEY = "comodo.auth";

export function readStoredAuth(expectedRole: AuthRole): RoleAuth | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<RoleAuth>;
    if (parsed.role !== expectedRole) return null;
    if (typeof parsed.token !== "string" || !parsed.token.trim()) return null;
    return { role: parsed.role, token: parsed.token.trim() };
  } catch {
    return null;
  }
}

export function writeStoredAuth(auth: RoleAuth): void {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(auth));
}

export function clearStoredAuth(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}
